var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PosAngleData = require("../abstract/posAngleData.js");

var SymbolTerminalData = require("./symbolTerminalData.js");
var RectangleData = require("./../svg/rectangleData.js");
var TextData = require("./../svg/textData.js");
var LineData = require("./../svg/lineData.js");
var cio_config = require("cio-config");

var SymbolGeneratorData = function(position, angle){
    var self = this;
    this.makeObservableTreeNode();

    this.addPosAngle(position, angle);
    this.width = this.value("width", true, cio_config.types.positive_float.validator);
    this.height = this.value("height", true, cio_config.types.positive_float.validator);

    this.leftNameList   = this.list("leftNameList", true);    // TODO: Maybe try to create 1 nameList
    this.bottomNameList = this.list("bottomNameList", true);
    this.rightNameList  = this.list("rightNameList", true);
    this.topNameList    = this.list("topNameList", true);

    this.terminalPitch  = 20;

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        function () {
            var center = self.pos();
            var w = self.width()+40;    // TODO: take into account number of terminals to correctly calculate boundingbox
            var h = self.height(); //+40;
            return new lib_geometry.BoundingBox(center.x - w/2, center.y - h/2, w, h).getPoly().rotate(self.angle(), self.pos());
        },
        [this.pos, this.width, this.height]
    );

    this.boundingBox = this.cachedFunction("boundingBox",
        function () { return self.segmentedGeometry().getBB(); },
        [this.segmentedGeometry]
    );
};
lib_core.mixin(SymbolGeneratorData, lib_core.ObservableTreeNode, PosAngleData);
lib_core.JsonParser.registerClass(SymbolGeneratorData, "SymbolGeneratorData");

module.exports = SymbolGeneratorData;

SymbolGeneratorData.prototype.getMinBoxHeight = function() {
    var boxHeight = (Math.max(this.rightNameList.size()||0, this.leftNameList.size()||0)+1)*this.terminalPitch;

    var overload = 0;
    this.topNameList.forEach(function(idx, name) {
       if (name.length > overload)
           overload = name.length;
    });
    this.bottomNameList.forEach(function(idx, name) {
       if (name.length > overload)
           overload = name.length;
    });

    return Math.max(boxHeight, 2*this.terminalPitch) + Math.ceil(overload*9 / this.terminalPitch) * this.terminalPitch;
};

SymbolGeneratorData.prototype.getMinBoxWidth = function() {
    var boxWidth = (Math.max(this.topNameList.size()||0, this.bottomNameList.size()||0)+1)*this.terminalPitch;

    var overload = 0;
    this.leftNameList.forEach(function(idx, name) {
       if (name.length > overload)
           overload = name.length;
    });
    this.rightNameList.forEach(function(idx, name) {
       if (name.length > overload)
           overload = name.length;
    });

    return Math.max(boxWidth, 2*this.terminalPitch) + Math.ceil(overload*9 / this.terminalPitch) * this.terminalPitch;
};

SymbolGeneratorData.prototype.setMinBox = function(){
    this.width(this.getMinBoxWidth());
    this.height(this.getMinBoxHeight());
};

SymbolGeneratorData.prototype.getElements = function(absolutePositions) { // TODO: maybe this can become a shadow
    var self = this;

    var elements = {
        rectangle: new RectangleData(new lib_geometry.Coord(0,0), 0, this.width(), this.height(), false, 2),
        terminals: [],
        labels: [],
        lines: []
    };

    if (absolutePositions){
        elements.rectangle.pos(this.pos());
        elements.rectangle.angle(this.angle());
    }

    function addTerminalElements(name, pos, angle, textAngle, textAnchor){
        if (absolutePositions) {
            pos = pos.rotate(self.angle()).add(self.pos())
            angle = (angle + self.angle()) % 360
            textAngle = (textAngle + self.angle()) % 360;
        }

        var terminal = new SymbolTerminalData(pos, angle, name);
        elements.terminals.push(terminal);

        var label = new TextData(pos.add((new lib_geometry.Coord(-14, 0)).rotate(angle)), textAngle, name, "Verdana", 10, null, null, null, textAnchor, "central");
        elements.labels.push(label);

        var end = pos.add((new lib_geometry.Coord(-10, 0)).rotate(angle));
        var line = new LineData(pos.x, pos.y, end.x, end.y, 1);
        elements.lines.push(line);
    }

    var cTop    = this.topNameList.size();
    var cBottom = this.bottomNameList.size();
    var cLeft   = this.leftNameList.size();
    var cRight  = this.rightNameList.size();

    for(var i = 0; i < cLeft; i++) {
        var pos = new lib_geometry.Coord( -this.width()/2 - 10, +((cLeft-1)/2)*this.terminalPitch - i*this.terminalPitch);
        addTerminalElements(this.leftNameList.get(i), pos, 180, 0, "start");
    }
    for(var i = 0; i < cBottom; i++) {
        var pos = new lib_geometry.Coord( - ((cBottom-1)/2)*this.terminalPitch + i*this.terminalPitch, -this.height()/2.0 - 10);
        addTerminalElements(this.bottomNameList.get(i), pos, 270, 90, "start");
    }
    for(var i = 0; i < cRight; i++) {
        var pos = new lib_geometry.Coord( this.width()/2.0 + 10, -((cRight-1)/2)*this.terminalPitch + i*this.terminalPitch);
        addTerminalElements(this.rightNameList.get(i), pos, 0, 0, "end");
    }
    for(var i = 0; i < cTop; i++) {
        var pos = new lib_geometry.Coord( ((cTop-1)/2)*this.terminalPitch - i*this.terminalPitch, +this.height()/2.0 + 10);
        addTerminalElements(this.topNameList.get(i), pos, 90, 90, "end");
    }

    return elements;
};

SymbolGeneratorData.prototype.expand = function(deterministic) {
    var self = this;

    var elements = this.getElements(true);
    var symbolData = this.parent();
    this.remove();

    if (deterministic) symbolData.root.registerNode(elements.rectangle, this.$id + "-outline");
    symbolData.shapes.push(elements.rectangle);

    elements.terminals.forEach(function(terminal, idx){ // add terminals
        if (deterministic) symbolData.root.registerNode(terminal, self.$id + "-t" + idx);   // TODO: maybe start a new list per nameList
        symbolData.terminals.add(terminal);
    });

    elements.labels.forEach(function(label, idx){    // add labels
        if (deterministic) symbolData.root.registerNode(label, self.$id + "-c" + idx);
        symbolData.shapes.push(label);
    });

    elements.lines.forEach(function(line, idx){    // add lines
        if (deterministic) symbolData.root.registerNode(line, self.$id + "-l" + idx);
        symbolData.shapes.push(line);
    });
};